import React from 'react';
import { Box, Typography, Chip, useMediaQuery, useTheme } from '@mui/material';
import { CheckCircle as CheckIcon } from '@mui/icons-material';

interface StepFormLayoutProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  progress: number;
  children: React.ReactNode;
  showOptionalBadge?: boolean;
}

const StepFormLayout: React.FC<StepFormLayoutProps> = ({
  title,
  description,
  icon,
  progress,
  children,
  showOptionalBadge = false
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const hideMobileProgress = process.env.REACT_APP_HIDE_MOBILE_PROGRESS === 'true';
  return (
    <>
      {/* Header with Progress */}
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          {/* Hide icon on mobile when env variable is set */}
          {!(isMobile && hideMobileProgress) && icon}
          <Box sx={{ flex: 1 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, color: 'text.primary' }}>
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </Box>
          {/* Hide progress chip on mobile when env variable is set */}
          {!showOptionalBadge && !(isMobile && hideMobileProgress) && (
            <Chip 
              icon={<CheckIcon />}
              label={`${Math.round(progress)}% Complete`}
              color={progress === 100 ? 'success' : 'default'}
              variant={progress === 100 ? 'filled' : 'outlined'}
            />
          )}
        </Box>
      </Box>
      
      {/* Form Content */}
      {children}
    </>
  );
};

export default StepFormLayout; 